import TipoIndicador from ".."
import LC from "entity/Indicador/LC"
import LBM from "entity/Indicador/LBM"
import BA from "entity/Indicador/BA"
import PragaSolo from "entity/Indicador/PragaSolo"
import PSM from "entity/Indicador/PSM"

export default class Pragas extends TipoIndicador {
    static get fullName() {
        return "Pragas"
    }

    static get abbrev() {
        return "Pragas"
    }

    static get field() {
        return "pragas"
    }

    static get indicadores() {
        return [LC, LBM, BA, PragaSolo, PSM]
    }
}
